import {Controller} from "stimulus"
import flatpickr from "flatpickr"

export default class extends Controller {

    static targets = [
    ]

    initialize() {

        // Initialise all datepickers
        const $pickers = [...document.querySelectorAll(".js-datepicker")]

        $pickers.forEach($picker => {

            let pickerOpts = $picker.dataset.opts

            let opts = {
                //"locale": French, // locale for this instance only
                altInput: true,
                dateFormat: "d-m-Y",
                altFormat: "j F, Y",
            }

            if (pickerOpts) {
                pickerOpts = JSON.parse(pickerOpts)
                opts = Object.assign({}, opts, pickerOpts)
            }

            /**
             * For input date
             */
            if (!opts.defaultDate) {
                const date = new Date()
                opts.defaultDate = `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`
            }

            flatpickr($picker, opts)

        })

    }

    back(e){
        e.preventDefault()
        console.log("going back")
        history.back()
    }


}